import { Sell } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import {
  FilterAccordionContainer,
  FilterCollapsibleList,
  FilterContainer,
  FilterFooter,
  FilterHeader,
} from '~/components/Filter';
import type { ShowList__FilterCount } from '../../queries/queries.generated';
import { useShowFilters } from '../context';

interface FilterAccordionProps {
  filterCounts?: ShowList__FilterCount;
}

export const FilterAccordion = ({ filterCounts }: FilterAccordionProps) => {
  const { t } = useTranslation();
  const { filters, clearFilters, setFilter, toggleFilter } = useShowFilters();
  const items = filters.tags.items;

  return (
    <FilterContainer>
      <FilterHeader />
      <FilterAccordionContainer>
        {items.length > 0 && (
          <FilterCollapsibleList
            Icon={Sell}
            expanded={filters.tags.open}
            items={items.map((item) => {
              const matched = filterCounts?.tags.find((c) => c.filter === item.value);
              return { ...item, count: matched?.count || 0 };
            })}
            label={t('common.labels.tags')}
            loading={!filterCounts}
            onClick={(_, newItems) => setFilter({ field: 'tags', items: newItems })}
            onExpand={() => toggleFilter('tags')}
          />
        )}
      </FilterAccordionContainer>
      <FilterFooter handleClear={clearFilters} />
    </FilterContainer>
  );
};
